import "../styles/Footer.css";
const partners_list = [
 { name: "The Joint Research Centre of the EU", abbr: "JRC" },
  { name: "Norwegian capacity to international operations", abbr: "NORCAP" },
  { name: "African Union", abbr: "AU" },
  { name: "Igad Climate Prediction and Applications Centre", abbr: "ICPAC" },
  { name: "World Meteorological Organization", abbr: "WMO" },
 
 
];

const FooterGeoportal = ({lastUpdated = {year:2026, lastUpdated: "Jan 7"},
                            partners = null}) => {
    if (partners === null) {
        partners = partners_list;
    }
  return (
      <footer className="geo-footer">
      <div className="geo-footer__inner">
        <div className="geo-footer__left">
          <span className="geo-footer__label">Partners:</span>

          <div className="geo-footer__partners">
            {partners.map((p) => (
              <div
                key={p.abbr}
                className="geo-footer__pill"
                title={p.name}
                role="button"
                tabIndex={0}
              >
                <span className="geo-footer__abbr">{p.abbr}</span>
                <span className="geo-footer__tooltip">{p.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="geo-footer__right">
          © {lastUpdated.year} ACMAD | Last updated: {lastUpdated.lastUpdated}
        </div>
      </div>
    </footer>
  )
}

export default FooterGeoportal
